require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./tapd-in-beginners-guide-to-google-shopping-ads.json") })
        }
      }, "path---tapd-in-beginners-guide-to-google-shopping-ads");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---tapd-in-beginners-guide-to-google-shopping-ads!./.cache/json/tapd-in-beginners-guide-to-google-shopping-ads.json
// module id = 810
// module chunks = 231608221292675